import { defineStore } from 'pinia'

const useComponentRefsStore = defineStore('componentRefs', {
  state: () => ({
    componentRefs: {}
  }),
  getters: {},
  actions: {
    setComponentRefs(uuid, el) {
      this.componentRefs[uuid] = el
    },
    getComponentRefs(uuid) {
      return this.componentRefs[uuid] || null
    }
  }
})

export default useComponentRefsStore
